// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coininn",
    name: "Coininn Wallet",
    homepage: "https://www.coininn.com/coinwallet",
    image_id: "52efd5a7-65fa-428d-668c-f53ceb4b5f00",
    app: {
        browser: null,
        ios: "https://itunes.apple.com/app/id6448525015",
        android: "https://play.google.com/store/apps/details?id=com.coininn.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "coininn_wallet_wc://request",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map